/**
 * 全部工单
 */
<template>
  <div class="mytodo">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>提交工单</el-breadcrumb-item>
      <el-breadcrumb-item @click="this.active--">选择问题分类</el-breadcrumb-item>
      <el-breadcrumb-item v-if="active==2">新建工单</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="box-card">
      <!-- 问题分类 -->
      <el-collapse v-model="activeNames" v-if="active==1">
        <el-collapse-item v-for="item in questionsType" :key="item.title" :name="index">
          <template slot="title">
            {{item.title}}
          </template>
          <el-row :gutter="20">
            <el-col :span="5" v-for="item2 in item.children" :key="item2.title">
              <div class="grid-content row-bg" @click="next">
                <div class="grid-content-r">
                  <span>{{item2.title}}</span> <br>
                  <span class="grid-content-r-discribe">{{item2.discribe}}</span>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-collapse-item>
      </el-collapse>

      <!-- 工单内容 -->
      <el-form v-if="active==2" ref="form" :model="form" label-width="80px">
        <el-form-item label="标题">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="紧急程度">
          <el-select clearable size="mini" v-model="form.type" placeholder="">
            <el-option label="一般" :value="0">
            </el-option>
            <el-option label="紧急" :value="1">
            </el-option>
            <el-option label="非常紧急" :value="2">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="内容">
          <div>
            <MyEditorComponent :contentDefault="contentDefault"></MyEditorComponent>
            <!-- <el-button type="" size="small" @click="raplyButtonShow =!raplyButtonShow">取消</el-button>
            <el-button type="primary" size="small">保存</el-button> -->
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary">提交</el-button>
          <!-- <el-button>取消</el-button> -->
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
// 导入组件
import MyEditorComponent from '../../components/MyEditorComponent.vue'

export default {
  name: 'mytodo',
  // 注册组件
  components: {
    MyEditorComponent
  },
  data() {
    return {
      activeNames: [0],
      form: {
        name: '',
        type: 1
      },
      active: 1,
      contentDefault: {},
      questionsType: [
        {
          title: '中目视频会议',
          children: [
            {
              title: '帐号问题',
              discribe: '无法登录、免费帐号。。。'
            },
            {
              title: '音视频问题',
              discribe: '无法连接语音、黑屏。。。'
            }
          ]
        },
        {
          title: 'webex视频会议',
          children: [
            {
              title: '帐号问题',
              discribe: '无法登录、免费帐号。。。'
            },
            {
              title: '音视频问题',
              discribe: '无法连接语音、黑屏。。。'
            },
            {
              title: '帐号问题',
              discribe: '无法登录、免费帐号。。。'
            },
            {
              title: '音视频问题',
              discribe: '无法连接语音、黑屏。。。'
            },
            {
              title: '音视频问题',
              discribe: '无法连接语音、黑屏。。。'
            }
          ]
        }
      ]
    }
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {},

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    next() {
      this.active++
      console.log(this.active)
    }
  },
  filters: {}
}
</script>

<style scoped>
.box-card {
  margin-top: 20px;
}
.row-bg {
  padding: 10px 0;
  /* background-color: #f2f2f2; */
  border: 1px solid #dcdfe6;
  margin-left: 0;
  margin-top: 12px;
  padding: 10px 20px;
  font-size: 14px;
  border-radius: 4px;
  font-weight: 400;
}
.row-bg:hover {
  border: 1px solid #409eff;
}
.grid-content {
  display: flex;
  color: #444;
}
.grid-content-l {
  width: 20%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.grid-content-l img {
  height: 40px;
  width: 40px;
}
.grid-content-r {
  /* text-align: center; */
  /* align-items: center; */
  /* justify-content: center; */
  /* display: flex; */
  text-align: center;
  /* width: 50%; */
  padding: 5px 0px;
}

.grid-content-r-discribe {
  color: #999;
  margin-top: 6px;
  font-size: 12px;
}

.w-100 {
  width: 100px;
}
.w-120 {
  width: 120px;
}
.w-150 {
  width: 150px;
}
.w-180 {
  width: 180px;
}
</style>

<style >
.mytodo .el-steps--simple {
  background: #f0f2f5;
}
.mytodo .el-divider {
  height: 50px;
}
.mytodo .el-step.is-simple .el-step__icon {
  width: 22px;
  height: 22px;
  font-size: 14px;
}
.mytodo .el-row {
  margin-bottom: 10px;
}

.mytodo .el-collapse {
  border-top: 0px solid #ebeef5;
  border-bottom: 0px solid #ebeef5;
}
.mytodo .el-collapse-item__header {
  border-left: 3px solid #409eff;
  padding-left: 5px;
  border-bottom: 0px solid #ebeef5;
  align-items: center;
  font-size: 16px;
  height: 22px;
}
.mytodo .el-collapse-item__header i {
  /* display: none; */
}
.mytodo .el-collapse-item {
  margin-top: 20px;
}
.mytodo .el-collapse-item__wrap {
  border-bottom: 0px solid #ebeef5;
}
</style>

 
 


// WEBPACK FOOTER //
// src/views/workorder/Mytodo.vue